export const HELLOFLEX_TEXTAREA_CLASS = 'helloflex-textarea';
